module.exports = __webpack_public_path__ + "static/media/content@2x.16a6b91a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/content@2x.png
// module id = 818
// module chunks = 0